import { RpcLogRecord } from './rpc-log-model';

/**
 * Rpc log sever side handler interface.
 */
export interface RpcLogHandler {
    handler(data: RpcLogRecord): Promise<void>;
}
